module.exports = __webpack_public_path__ + "static/media/unavailable-building-black.eec0e92e.svg";